import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const data = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May"],
  datasets: [
    {
      label: "Attendance",
      data: [12, 19, 14, 20, 16],
      backgroundColor: "rgba(59, 130, 246, 0.7)"
    }
  ]
};

export default function AttendanceChart() {
  return <Bar data={data} />;
}
